import { useEffect } from 'react';

export const useOutline = () => {
  useEffect(() => {
    const htmlEl = document.querySelector('html');
    document.addEventListener('click', () => htmlEl?.classList.remove('a11y'));

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      const isTab = /^tab$/i.test(e.key);

      if (isTab) {
        htmlEl?.classList?.add('a11y');
      }
    });
  }, []);
};
